const scope_0 = require('/opt/build/repo/.cache/caches/gatsby-mdx/mdx-scopes-dir/1970366a8c100bb8e42caab4bfa24659.js').default;
const scope_1 = require('/opt/build/repo/.cache/caches/gatsby-mdx/mdx-scopes-dir/3cad7b1991e7961ded7213937f1b6536.js').default;
const scope_2 = require('/opt/build/repo/.cache/caches/gatsby-mdx/mdx-scopes-dir/ee7b4977d56500828498100b7e6a7d5c.js').default;export default
        Object.assign({}, scope_0,
scope_1,
scope_2 )
    